import { useInfiniteLocationsDataSource } from 'custom_hooks/data_hooks/data_source/locationsDataSource';
import { useDrainDataSource } from 'custom_hooks/data_hooks/data_source/useDrainDataSource';
import { useMemo } from 'react';
import { MultiSelectQuickFilterButton } from 'shared/filter_pane/MultiSelectQuickFilterButton';
import { sortBy } from 'utils/array';

export type LocationFilterButtonProps = {
    corporationId: string;
    locationIds: string[];
    onChangeLocationIds: (locationIds: string[]) => void;
};

export function LocationFilterButton({
    corporationId,
    locationIds,
    onChangeLocationIds,
}: LocationFilterButtonProps) {
    const { results: locations } = useDrainDataSource(
        useInfiniteLocationsDataSource({
            name: 'location-filter-locations',
            defaultFilter: { nameSearch: '', corporationId, active: true },
        })
    );

    const options = useMemo(() => {
        if (!locations) {
            return [];
        }

        return sortBy(locations, (l) => l.Name).map((location) => ({
            value: location.Id,
            label: location.Name,
        }));
    }, [locations]);

    return (
        <MultiSelectQuickFilterButton
            id="location-filter"
            label="Location"
            selectedValues={locationIds}
            onChangeValues={onChangeLocationIds}
            options={options}
        />
    );
}
